import { useCallback, useEffect, useRef, useState } from 'react';

import { useRefreshOnReturn } from '@/admin/data/useAdminQuery';

/**
 * Jeton de relecture des ecrans d'exploitation.
 *
 * Deux gestes relisent, et rien d'autre : le bouton (`refresh`) et le retour sur
 * l'onglet **apres au moins 30 secondes** sans lecture. Aucune minuterie : chaque
 * lecture d'une route `/admin/*` ecrit une ligne d'audit (ADR 0035 §4), et un
 * rafraichissement toutes les 30 s en ecrirait 2 880 par jour et par onglet
 * ouvert. Le delai evite qu'un aller-retour d'onglet rapide relise pour rien.
 */

export const REFRESH_AFTER_RETURN_MS = 30_000;

export const useOperationsRefresh = (): { readonly token: number; readonly refresh: () => void } => {
  const [token, setToken] = useState(0);
  const lastRead = useRef(0);

  // La premiere lecture part au montage : la fenetre de 30 s court depuis lui.
  useEffect(() => {
    lastRead.current = Date.now();
  }, []);

  const refresh = useCallback(() => {
    lastRead.current = Date.now();
    setToken((previous) => previous + 1);
  }, []);

  const onReturn = useCallback(() => {
    if (Date.now() - lastRead.current >= REFRESH_AFTER_RETURN_MS) {
      refresh();
    }
  }, [refresh]);

  useRefreshOnReturn(onReturn);

  return { token, refresh };
};
